// SmsKapıda brand — round logo (icon-cropped) + wordmark alongside.
export default function Brand({ size = "md" }) {
  const config = {
    sm: { logo: "w-11 h-11", text: "text-xl", pos: "35%" },
    md: { logo: "w-14 h-14", text: "text-2xl", pos: "35%" },
    lg: { logo: "w-20 h-20", text: "text-4xl", pos: "35%" },
    xl: { logo: "w-28 h-28", text: "text-6xl", pos: "35%" },
  };
  const c = config[size] || config.md;
  return (
    <span className="inline-flex items-center gap-3 select-none">
      <span
        className={`${c.logo} rounded-full overflow-hidden shrink-0 relative`}
        style={{
          boxShadow: "0 6px 18px -6px hsl(43 74% 55% / 0.55), inset 0 0 0 2px hsl(43 74% 55% / 0.55), inset 0 0 0 3px hsl(220 45% 8%)",
          background: "hsl(220 45% 8%)",
        }}
      >
        <img
          src="/brand/smskapinda-logo.png"
          alt="SmsKapıda"
          className="w-full h-full object-cover"
          style={{ objectPosition: `50% ${c.pos}`, transform: "scale(1.55)" }}
          loading="eager"
          decoding="async"
        />
      </span>
      <span className={`font-display font-black tracking-tight ${c.text} leading-none`}>
        <span style={{
          background: "linear-gradient(180deg, hsl(43 90% 68%) 0%, hsl(43 74% 45%) 100%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}>Sms</span>
        <span style={{
          background: "linear-gradient(180deg, hsl(0 0% 96%) 0%, hsl(0 0% 78%) 100%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}>Kapıda</span>
      </span>
    </span>
  );
}

export function BrandText({ className = "" }) {
  return (
    <span className={`font-display font-black tracking-tight ${className}`}>
      <span style={{ color: "hsl(43 74% 55%)" }}>Sms</span>
      <span className="text-white/95">Kapıda</span>
    </span>
  );
}
